import { GET_TASKS } from 'actions/types';
import { transformActions } from 'utils/';

const initialState = {
  data: [],
  isLoading: false,
};

let taskList = [];

/**
  @description Stores tasks array details in redux state
  @param {[]} state
  @param {{}} action
  @returns {[]}
 */
function tasks(state = initialState, action) {
  const { type, payload } = action;
  const actions = [GET_TASKS];
  const success = transformActions(actions, 'SUCCESS');
  const failure = transformActions(actions, 'FAILURE');

  if (type === GET_TASKS) {
    return {
      data: taskList,
      isLoading: true,
    };
  }

  if (success.includes(type)) {
    taskList = payload;
    return {
      data: taskList,
      isLoading: false,
    };
  }

  if (failure.includes(type)) {
    return {
      data: taskList,
      isLoading: false,
    };
  }

  return state;
}

export default tasks;
